import ProfileParticipationSummary from "./ProfileParticipationSummary";

export default ProfileParticipationSummary;
